import React from "react";
import "../Styles/VDCGridCentreLayout.css"; // Optional: extract styles here
import { FaPhone, FaMicrophoneSlash, FaPause, FaPhoneSlash, FaVideo, FaVideoSlash } from "react-icons/fa";
import AdvertisementImage from "../../../../../assets/Advertisement/Swimming-advt.jpeg"


const UMGridCentreLayout = ( {userId} ) => {
  return (
    <div className="vdc-centre-layout">

      <div className="vdc-advertisement-container">
        <img src={AdvertisementImage} alt="Decorative" className="frame-image" />
      </div>

      {/* Ongoing Audio Call Section */}
      <div className="vdc-Video-call-banner" style={{marginTop: 100}}>
        <h1 style={{fontSize: 50}}> 🔊 Ongoing Video Call... </h1>
      </div>

      {/* Profile and Call Controls Section */}
      <div className="call-controls-container" style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "black",
        padding: 16,
        borderRadius: 12,
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        marginTop: 200,
      }}>
        
        {/* Profile Picture and Name */}
        <div className="profile-info" style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
          <img
            src="../../../../../../assets/avatar/avatar-4.png"
            alt="Profile"
            style={{ width: 30, height: 30, borderRadius: "50%", marginRight: 12 }}
          />
          <div style={{ fontSize: 18, fontWeight: 600 }}> {userId} </div>
        </div>

        {/* Call Control Buttons */}
        <div className="control-buttons" style={{ display: "flex", gap: 12 }}>
          <button className="call-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaVideo /> Call</button>
          <button className="call-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaVideoSlash /> Off Video</button>
          <button className="mute-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaMicrophoneSlash /> Mute</button>
          <button className="hold-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaPause /> Hold</button>
          <button className="cut-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaPhoneSlash /> End</button>
        </div>
      </div>
    </div>
  );
};

const btnStyle = {
  padding: "10px 16px",
  borderRadius: "8px",
  border: "none",
  backgroundColor: "#e0e0e0",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontWeight: "bold"
};

export default UMGridCentreLayout;
